export enum OcrExtractionType {
  STUDENT_ANSWER = 'student-answer',
  TASK_DESCRIPTION = 'task-description',
  MASTER_SOLUTION = 'master-solution',
  GRADING_CRITERIA = 'grading-criteria',
  ADDITIONAL_INFO = 'additional-info',
  LANGUAGE_USE_RULES = 'language-use-rules',
  GENERIC = 'generic',
}
